// @flow
import * as React from 'react';
import ReactDOM from 'react-dom';

type IntersectionObserverProps = {
  children?: React.Element<any>,
  options?: IntersectionObserverOptions,
  onVisibilityChange: IntersectionObserverCallback,
};

// IntersectionObserver
// This component is a wrapper around the IntersectionObserver API.

// TODO(tuanhuynh) create an IntersectionObserverManager that
// 1) serializes the options
// 2) creates a map of IntersectionObservers shared between <IntersectionObserver />
//    and the withIntersectionObserver HOC

class IntersectionObserver extends React.Component<IntersectionObserverProps> {
  componentDidMount() {
    const node = ReactDOM.findDOMNode(this);
    if (node instanceof HTMLElement) {
      this.node = node;
    }

    if (this.node) {
      // Passing this.props.onVisibilityChanged directly into the constructor
      // prevents dynamically setting the onVisibilityChange handler
      this.observer = new window.IntersectionObserver(
        this.handleVisibilityChanged,
        this.props.options,
      );

      this.observer.observe(this.node);
    }
  }

  UNSAFE_componentWillUpdate(nextProps: IntersectionObserverProps) {
    // TODO(tuanhuynh) if options changed, then we will need
    // to create a new IntersectionObserver
  }

  componentWillUnmount() {
    if (this.observer !== null) {
      this.observer.unobserve(this.node);
      delete this.observer;
    }
  }

  observer = null;
  node: HTMLElement;

  handleVisibilityChanged: IntersectionObserverCallback = (entries, observer) => {
    this.props.onVisibilityChange(entries, observer);
  };

  render() {
    return React.Children.only(this.props.children);
  }
}

export default IntersectionObserver;
